import {Modal} from "@luciad/ria-sample-common/components/Modal";
import React from "react";
import {useWizard} from "../hooks/useWizard";

interface ModalPage<K extends string> {
  title: string;
  render: (changePage: (pageKey: K) => void, previousPageKey: K, resetWizard: () => void) => JSX.Element;
}

export type ModalPages<K extends string> = { [pageKey: string]: ModalPage<K> };

export interface WizardPageProps<K extends string> {
  changePage: (pageKey: K) => void;
  previousPageKey: K;
  resetWizard: () => void;
}

interface Props<K extends string> {
  show: boolean;
  onHide: () => void;
  startPageKey: K;
  pages: ModalPages<K>;
}

export function ModalWizard<K extends string>({show, startPageKey, pages, onHide}: Props<K>) {
  const {currentPageKey, previousPageKey, changePage, resetWizard} = useWizard(startPageKey, onHide);
  const page = pages[currentPageKey];
  if (!page) {
    throw new Error(`Could not find page with key ${currentPageKey}`)
  }
  return (
      <Modal show={show} title={page.title} onHide={resetWizard}>
        {page.render(changePage, previousPageKey, resetWizard)}
      </Modal>
  );
}